module.exports = __webpack_public_path__ + "static/img/作品62.eefb8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品62.png
// module id = 5zzZ
// module chunks = 1